import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import { useFetchDetail, usePostDetail } from "@hooks/useFetchDetail";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import AddEditFormCst from "@components/AddEditFormCst";
import { ServicesURL, uploadFile } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import ButtonBackPage from "@components/ButtonBackPage";

const AddCustomer: React.FC = () => {
  const { t } = useTranslation(["customers-budget-page"]);
  const { columns, actionsForForms } = useFetchDetail(
    ServicesURL.getCustomers,
    undefined,
    PagesID["customers"],
  );

  const navigate = useNavigate();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
    description?: string;
  }>();

  const { trigger: triggerCustomer } = usePostDetail(ServicesURL.postCustomers);

  const onSubmit = async (inputForm: any) => {
    setOpenToast({ s: StatusEnum.LOADING, message: "loading" });
    const objToSend: any = {
      sap_code: inputForm.sap_code || null,
      business_name: inputForm.business_name || null,
      vat_identification_number: inputForm.vat_identification_number || null,
      fiscal_code: inputForm.fiscal_code || null,
      contact_person_name: inputForm.contact_person_name || null,
      contact_person_email: inputForm.contact_person_email || null,
      notes: inputForm.notes || null,
    };

    try {
      await triggerCustomer(objToSend);
      setOpenToast({ s: StatusEnum.OK, message: "" });
    } catch (error) {
      setOpenToast(undefined);
      console.error(error);
    }
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-customers.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <AddEditFormCst
              columns={columns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(-1);
              }}
              fullWidth={true}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default AddCustomer;
